import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import Link from '@mui/material/Link';
import team4 from 'assets/images/Logo principal.png';
import gogle from 'assets/images/patner.png';
import { Stack } from '@mui/material';

function CustomFooter({ light = false }) {
  const navigate = useNavigate();
  const location = useLocation();

  const mainLinks = [
    { name: 'Nosotros', scrollToId: 'nosotros' },
    { name: 'Productos', scrollToId: 'testimonials-two' },
    { name: 'Servicios', scrollToId: 'servicios' },
    { name: 'Contáctanos', scrollToId: 'contact-us' },
  ];

  // Navegar a la sección: si estamos en la landing page principal hacer scroll, si no, redirigir
  const handleScroll = (id) => {
    const isHome = location.pathname === '/' || location.pathname.toLowerCase() === '/aboutus';
    if (isHome) {
      const element = document.getElementById(id);
      if (element) {
        // Obtenemos la distancia del elemento desde la parte superior
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;

        // Ajuste temporal para asegurar que carguen los elementos, y hacemos un scroll suave.
        setTimeout(() => {
          window.scrollTo({
            top: elementPosition - 100, // dejamos un margen de 100px para evitar que quede pegado
            behavior: 'smooth',
          });
        }, 100);
      }
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  return (
    <MKBox component="footer" py={9} mt={-20} alignItems="center" textAlign="center">
      <Container maxWidth="lg">
        {/* Mapa */}
        {/* <MKBox pt={-20} px={1} mt={-10}>
          <GoogleMap />
        </MKBox> */}

        {/* Footer en 4 columnas */}
        <Grid container spacing={4} mt={1} justifyContent="center">
          {/* Columna 1: Logo + LinkedIn (LinkedIn debajo y centrado) */}
          <Grid item xs={12} md={3} textAlign="center" mt={-2}>
            <MKBox>
              <MKBox component="img" src={team4} alt="Logo empresa" width="200px" />

              <MKTypography variant="body2" fontSize="14px" mt={-2}>
                Generamos capacidades tecnológicas al interior de tu organización para impulsar su
                transformación digital.
              </MKTypography>
            </MKBox>

            <MKBox display="flex" justifyContent="center" alignItems="center" mt={1}>
              <Stack direction="row" spacing={2} justifyContent="center">
                <MKBox component="img" src={gogle} alt="Google Partner" width="100px" />
                <Link
                  href="https://www.linkedin.com/company/dev-codes/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: 'inline-flex', alignItems: 'center' }}
                >
                  <LinkedInIcon sx={{ fontSize: 36, color: light ? 'white' : '#0077B5' }} />
                </Link>
              </Stack>
            </MKBox>
          </Grid>

          {/* Columna 2: Enlaces rápidos */}
          <Grid item xs={12} md={5} textAlign="center">
            <MKTypography variant="h6" color={light ? 'white' : 'text'}>
              Menú
            </MKTypography>
            <MKBox component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {mainLinks.map(({ name, scrollToId }) => (
                <MKBox
                  key={name}
                  onClick={() => handleScroll(scrollToId)}
                  sx={{
                    cursor: 'pointer',

                    '&:hover': {
                      color: 'primary.main',
                    },
                  }}
                >
                  <MKTypography variant="button" color={light ? 'white' : 'text'}>
                    {name}
                  </MKTypography>
                </MKBox>
              ))}
            </MKBox>
          </Grid>

          {/* Columna 4: Contacto + Google Partner */}
          <Grid item xs={12} md={3} textAlign="center">
            <MKBox display="flex" justifyContent="center" alignItems="center" gap={20} mb={2}>
              {/* Título "Contacto" */}

              {/* Logo de Google */}
            </MKBox>
            {/* Información de contacto */}
            <MKTypography variant="body2" fontSize="14px" color={light ? 'white' : 'text'} mb={0}>
              <strong>El Salvador:</strong> contact@dev-codes.io
            </MKTypography>
            <MKTypography variant="body2" fontSize="14px" color={light ? 'white' : 'text'} mb={2}>
              (+503) 7237 1112
            </MKTypography>
            <MKTypography variant="body2" fontSize="14px" color={light ? 'white' : 'text'} mb={0}>
              <strong>Colombia:</strong> comercial@dev-codes.com
            </MKTypography>
            {/* <MKTypography variant="body2" fontSize="14px" color={light ? 'white' : 'text'} mb={1}>
              (+57) 301 421 2451
            </MKTypography> */}
          </Grid>
        </Grid>

        {/* Línea separadora y derechos reservados */}
        <MKBox mt={6} textAlign="center">
          <MKTypography variant="caption" color="text" fontWeight="light">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </MKTypography>
        </MKBox>
      </Container>
    </MKBox>
  );
}

CustomFooter.propTypes = {
  light: PropTypes.bool,
};

export default CustomFooter;

// import PropTypes from 'prop-types';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import MKBox from 'components/MKBox';
// import MKTypography from 'components/MKTypography';
// import Link from '@mui/material/Link';
// import team4 from 'assets/images/Logo principal.png';
// import gogle from 'assets/images/patner.png';
// import { Stack } from '@mui/material';

// function CustomFooter({ light = false }) {
//   const mainLinks = [
//     { name: 'Nosotros', scrollToId: 'nosotros' },
//     { name: 'Productos', scrollToId: 'testimonials-two' },
//     { name: 'Servicios', scrollToId: 'servicios' },
//     { name: 'Contáctanos', scrollToId: 'contact-us' },
//   ];

//   const handleScroll = (id) => {
//     const element = document.getElementById(id);
//     if (element) element.scrollIntoView({ behavior: 'smooth' });
//   };

//   return (
//     <MKBox component="footer" py={9} mt={-20} alignItems="center" textAlign="center">
//       <Container maxWidth="lg">
//         <Grid container spacing={4} mt={1} justifyContent="center">
//           {/* Columna 1: Logo + LinkedIn */}
//           <Grid item xs={12} md={3} textAlign="center" mt={-2}>
//             <MKBox>
//               <MKBox component="img" src={team4} alt="Logo empresa" width="200px" />
//               <MKTypography variant="body2" fontSize="14px" mt={-2}>
//                 Generamos capacidades tecnológicas al interior de tu organización para impulsar su
//                 transformación digital.
//               </MKTypography>
//             </MKBox>

//             <MKBox display="flex" justifyContent="center" alignItems="center" mt={1}>
//               <Stack direction="row" spacing={2} justifyContent="center">
//                 <MKBox component="img" src={gogle} alt="Google Partner" width="100px" />
//                 <Link
//                   href="https://www.linkedin.com/company/dev-codes/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   sx={{ display: 'inline-flex', alignItems: 'center' }}
//                 >
//                   <LinkedInIcon sx={{ fontSize: 36, color: light ? 'white' : '#0077B5' }} />
//                 </Link>
//               </Stack>
//             </MKBox>
//           </Grid>

//           {/* Menú horizontal */}
//           <Grid item xs={12} md={9} textAlign="center" mt={7}>
//             <MKBox display="flex" justifyContent="center" flexWrap="wrap" gap={7}>
//               {mainLinks.map(({ name, scrollToId }) => (
//                 <MKTypography
//                   key={name}
//                   variant="button"
//                   color={light ? 'white' : 'text'}
//                   onClick={() => handleScroll(scrollToId)}
//                   sx={{
//                     cursor: 'pointer',
//                     transition: 'color 0.3s',
//                     '&:hover': { color: '#1976d2' },
//                   }}
//                 >
//                   {name}
//                 </MKTypography>
//               ))}
//             </MKBox>
//           </Grid>
//         </Grid>

//         {/* Línea separadora y derechos reservados */}
//         <MKBox mt={6} textAlign="center">
//           <MKTypography variant="caption" color="text" fontWeight="light">
//             &copy; {new Date().getFullYear()} Todos los derechos reservados.
//           </MKTypography>
//         </MKBox>
//       </Container>
//     </MKBox>
//   );
// }

// CustomFooter.propTypes = {
//   light: PropTypes.bool,
// };

// export default CustomFooter;
